/** 
 * api接口统一管理
 */
import {get, post, postform } from './axios';


/**
 * 
 * @param {string} params 
 * 我们定义了一个topics方法
 * 这个方法有一个参数params
 * params是我们请求接口时携带的参数对象
 * 而后调用了我们封装的post方法
 * post方法的第一个参数是我们的接口地址
 * 第二个参数是topics的params参数
 * 即请求接口时携带的参数对象
 * 最后通过export导出topics。
 */

// 登录
// export const reqLogin = params => post('/iveco/user/login', params)

// 查询轮播图列表
export const reqBanners = params => postform('/iveco/navigat/getNavigateList', params)
    //     // 轮播图详情
    // export const reqBannersDetail = params => post('/iveco/navigat/getNavigateDetail', params)
    //     // 添加轮播图
    // export const reqBannersAdd = params => post('/iveco/navigat/addNavigate', params)
    //     // 修改轮播图
    // export const reqBannersUpdate = params => post('/iveco/navigat/updateNavigateById', params)
    //     // 删除轮播图
    // export const reqBannersDelete = params => post('/iveco/navigat/deleteNavigateById', params)
    //     // 上传轮播图
    // export const reqBannersUpload = params => post('/iveco/navigat/uploadNavigatImg', params)


// // 查询用户列表
// export const reqUserList = params => post('/iveco/user/getUserList', params)
//     // 查询用户详情
// export const reqUserDetail = params => post('/iveco/user/getUserDetail', params)
//     // 添加用户
// export const reqUserAdd = params => post('/iveco/user/addUser', params)
//     // 修改用户
// export const reqUserUpdate = params => post('/iveco/user/updateUser', params)
//     // 删除用户
// export const reqUserDelete = params => post('/iveco/user/deleteUserById', params)
//     // 修改用户密码
// export const reqUserPassword = params => post('/iveco/user/updatePassword', params)


// 查询新闻列表
export const reqNewsList = params => postform('/iveco/news/getNewsList', params)
    // 查询新闻详情
export const reqNewsDetail = params => postform('/iveco/news/getNewsDetail', params)
    //     // 添加新闻
    // export const reqNewsAdd = params => post('/iveco/news/addNews', params)
    //     // 修改新闻
    // export const reqNewsUpdate = params => post('/iveco/news/updateNewsById', params)
    //     // 删除新闻
    // export const reqNewsDelete = params => post('/iveco/news/deleteNewsById', params)

// 提交联系我们
export const reqAddContactUsInfo = params => post('/iveco/contactUs/addContactUsInfo', params)


// WEBPACK FOOTER //
// ./src/untils/api.js